"use strict";
/**
 * This file is generated automatically. Do not change it manually!
 * Этот файл генерируется автоматически. Не изменяйте его вручную!
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllPermissionsWithAvailableValues = void 0;
exports.AllPermissionsWithAvailableValues = {
    'advanced.users.create': [false, 'manager', 'reseller', true],
    'advanced.users.update': [false, 'me', 'manager', 'reseller', true],
    'advanced.users.get': [false, 'me', 'manager', 'reseller', true],
    'advanced.users.find': [false, 'manager', 'reseller', true],
    'advanced.users.remove': [false, true],
    'advanced.users.setPermissions': [false, 'manager', 'reseller', true],
    'advanced.users.setTariffs': [false, 'manager', 'reseller', true],
    'advanced.users.setRoutingGroups': [false, 'manager', 'reseller', true],
    'advanced.users.setSendernames': [false, 'manager', 'reseller', true],
    'advanced.users.setPatterns': [false, 'manager', 'reseller', true],
    'advanced.users.setMessageRuleGroups': [false, 'manager', 'reseller', true],
    'advanced.users.setOtpChannels': [false, true],
    'advanced.notifications.get': [false, 'me', true],
    'advanced.notifications.setRead': [false, 'me', true],
    'advanced.notifications.trigger': [false, true],
    'advanced.sendings.generate': [false, true],
    'advanced.sendings.create': [false, true],
    'advanced.sendings.update': [false, true],
    'advanced.sendings.get': [false, 'me', 'reseller', 'manager', true],
    'advanced.sendings.find': [false, 'me', 'reseller', 'manager', true],
    'advanced.sendings.remove': [false, true],
    'advanced.sendingsIncoming.generate': [false, true],
    'advanced.sendingsIncoming.get': [false, 'me', 'reseller', true],
    'advanced.tariffs.create': [false, 'reseller', true],
    'advanced.tariffs.update': [false, 'reseller', true],
    'advanced.tariffs.get': [false, 'reseller', true],
    'advanced.tariffs.find': [false, 'reseller', true],
    'advanced.tariffs.remove': [false, 'reseller', true],
    'advanced.billings.finalize': [false, 'reseller', true],
    'advanced.billings.generate': [false, 'reseller', true],
    'advanced.billings.create': [false, true],
    'advanced.billings.update': [false, true],
    'advanced.billings.get': [false, 'reseller', true],
    'advanced.billings.find': [false, 'me', 'reseller', true],
    'advanced.billings.remove': [false, true],
    'advanced.storage.create': [false, 'me', 'reseller', true],
    'advanced.storage.update': [false, 'me', 'reseller', true],
    'advanced.storage.get': [false, 'me', 'reseller', true],
    'advanced.storage.remove': [false, 'me', 'reseller', true],
    'advanced.storage.upload': [false, 'me', 'reseller', true],
    'advanced.storage.download': [false, 'me', 'reseller', true],
    'advanced.reports.generate': [false, 'me', 'reseller', 'manager', true],
    'advanced.reports.get': [false, 'me', 'reseller', 'manager', true],
    'advanced.reports.presetUsersBalance': [false, true],
    'advanced.contacts.create': [false, 'me', 'reseller', true],
    'advanced.contacts.find': [false, 'me', 'reseller', true],
    'advanced.contacts.get': [false, 'me', 'reseller', true],
    'advanced.contacts.update': [false, 'me', 'reseller', true],
    'advanced.contacts.remove': [false, 'me', 'reseller', true],
    'advanced.sendernames.create': [false, 'me', 'reseller', true],
    'advanced.sendernames.get': [false, 'me', 'reseller', true],
    'advanced.sendernames.update': [false, 'me', 'reseller', true],
    'advanced.sendernames.remove': [false, 'reseller', true],
    'advanced.patterns.create': [false, 'me', 'reseller', true],
    'advanced.patterns.get': [false, 'me', 'reseller', true],
    'advanced.patterns.update': [false, 'me', 'reseller', true],
    'advanced.patterns.remove': [false, 'reseller', true],
    'advanced.templates.create': [false, 'me', 'reseller', true],
    'advanced.templates.get': [false, 'me', 'reseller', true],
    'advanced.templates.update': [false, 'me', 'reseller', true],
    'advanced.templates.remove': [false, 'me', 'reseller', true],
    'advanced.requisites.create': [false, 'me', 'reseller', 'manager', true],
    'advanced.requisites.get': [false, 'me', 'reseller', 'manager', true],
    'advanced.requisites.update': [false, 'me', 'reseller', 'manager', true],
    'advanced.requisites.remove': [false, 'me', 'reseller', 'manager', true],
    'advanced.requisites.controlDocuments': [false, 'me', 'reseller', true],
    'advanced.tasks.create': [false, 'reseller', true],
    'advanced.tasks.find': [false, 'me', 'reseller', true],
    'advanced.tasks.update': [false, 'me', 'reseller', true],
    'advanced.tasks.get': [false, 'me', 'reseller', true],
    'advanced.tasks.remove': [false, 'me', 'reseller', true],
    'advanced.payments.get': [false, 'me', 'reseller', true],
    'advanced.payments.create': [false, 'me', 'reseller', true],
    'advanced.payments.update': [false, 'reseller', true],
    'advanced.payments.remove': [false, true],
    'advanced.paymentLogs.get': [false, true],
    'advanced.recurrentPayments.get': [false, 'me', 'reseller', true],
    'advanced.recurrentPayments.create': [false, 'me', 'reseller', true],
    'advanced.recurrentPayments.update': [false, 'me', 'reseller', true],
    'advanced.recurrentPayments.remove': [false, 'me', 'reseller', true],
    'advanced.settingsSite.get': [false, 'reseller', true],
    'advanced.settingsSite.set': [false, 'reseller', true],
    'advanced.settingsUser.get': [false, 'me', 'reseller', true],
    'advanced.settingsUser.set': [false, 'me', 'reseller', true],
    'advanced.contracts.get': [false, 'reseller', true],
    'advanced.contracts.create': [false, 'reseller', true],
    'advanced.contracts.update': [false, 'reseller', true],
    'advanced.contracts.remove': [false, 'reseller', true],
    'advanced.companies.get': [false, 'me', 'reseller', true],
    'advanced.companies.create': [false, 'reseller', true],
    'advanced.companies.update': [false, 'reseller', true],
    'advanced.companies.remove': [false, 'reseller', true],
    'advanced.documentTemplates.find': [false, 'me', 'reseller', true],
    'advanced.documentTemplates.get': [false, 'me', 'reseller', true],
    'advanced.documentTemplates.create': [false, 'reseller', true],
    'advanced.documentTemplates.update': [false, 'reseller', true],
    'advanced.documentTemplates.remove': [false, 'reseller', true],
    'advanced.dictionaries.get': [false, 'reseller', true],
    'advanced.dictionaries.create': [false, 'reseller', true],
    'advanced.dictionaries.update': [false, 'reseller', true],
    'advanced.dictionaries.remove': [false, 'reseller', true],
    'advanced.dictionaries.seek': [false, true],
    'advanced.dictionaries.modify': [false, true],
    'advanced.operatorGroups.get': [false, 'reseller', true],
    'advanced.operatorGroups.create': [false, 'reseller', true],
    'advanced.operatorGroups.update': [false, 'reseller', true],
    'advanced.operatorGroups.remove': [false, 'reseller', true],
    'advanced.dadata.get': [false, true],
    'advanced.invoices.create': [false, 'me', 'reseller', 'manager', true],
    'advanced.invoices.get': [false, 'me', 'reseller', 'manager', true],
    'advanced.invoices.update': [false, 'reseller', 'manager', true],
    'advanced.invoices.remove': [false, true],
    'advanced.otp-settings.channels.create': [false, true],
    'advanced.otp-settings.channels.get': [false, 'me', true],
    'advanced.otp-settings.channels.update': [false, true],
    'advanced.otp-settings.channels.remove': [false, true],
    'advanced.otp-settings.templates.create': [false, true],
    'advanced.otp-settings.templates.get': [false, true],
    'advanced.otp-settings.templates.update': [false, true],
    'advanced.otp-settings.templates.remove': [false, true],
    'advanced.otp-settings.widgets.create': [false, 'me', true],
    'advanced.otp-settings.widgets.get': [false, 'me', true],
    'advanced.otp-settings.widgets.update': [false, 'me', true],
    'advanced.otp-settings.widgets.remove': [false, 'me', true],
    'advanced.otp-handler.use': [false, true],
    'advanced.otp-handler.get': [false, true],
    'advanced.servers.get': [false, true],
    'advanced.servers.create': [false, true],
    'advanced.servers.update': [false, true],
    'advanced.servers.remove': [false, true],
    'advanced.credentials.get': [false, true],
    'advanced.credentials.create': [false, true],
    'advanced.credentials.update': [false, true],
    'advanced.credentials.remove': [false, true],
    'advanced.providers.get': [false, true],
    'advanced.providers.find': [false, true],
    'advanced.providers.create': [false, true],
    'advanced.providers.update': [false, true],
    'advanced.providers.remove': [false, true],
    'advanced.providerGroups.get': [false, true],
    'advanced.providerGroups.find': [false, true],
    'advanced.providerGroups.create': [false, true],
    'advanced.providerGroups.update': [false, true],
    'advanced.providerGroups.remove': [false, true],
    'advanced.routingRules.get': [false, true],
    'advanced.routingRules.find': [false, true],
    'advanced.routingRules.create': [false, true],
    'advanced.routingRules.update': [false, true],
    'advanced.routingRules.remove': [false, true],
    'advanced.routingGroups.get': [false, true],
    'advanced.routingGroups.find': [false, true],
    'advanced.routingGroups.create': [false, true],
    'advanced.routingGroups.update': [false, true],
    'advanced.routingGroups.remove': [false, true],
    'advanced.tokens.create': [false, 'me', 'reseller', true],
    'advanced.tokens.get': [false, 'me', 'reseller', true],
    'advanced.tokens.update': [false, 'me', 'reseller', true],
    'advanced.tokens.remove': [false, 'me', 'reseller', true],
    'advanced.apisender.get': [false, 'me', 'reseller', true],
    'advanced.apisender.create': [false, 'me', 'reseller', true],
    'advanced.apisender.update': [false, 'me', 'reseller', true],
    'advanced.apisender.remove': [false, 'me', 'reseller', true],
    'advanced.keywords.create': [false, true],
    'advanced.keywords.get': [false, true],
    'advanced.keywords.update': [false, true],
    'advanced.keywords.remove': [false, true],
    'advanced.keywords.matchKeywords': [false, true],
    'advanced.messageRuleGroups.create': [false, true],
    'advanced.messageRuleGroups.get': [false, true],
    'advanced.messageRuleGroups.update': [false, true],
    'advanced.messageRuleGroups.remove': [false, true],
    'advanced.messageRules.create': [false, true],
    'advanced.messageRules.get': [false, true],
    'advanced.messageRules.update': [false, true],
    'advanced.messageRules.remove': [false, true],
    'advanced.yclients.create': [false, true],
    'advanced.yclients.update': [false, true],
    'advanced.yclients.get': [false, true],
    'advanced.yclients.remove': [false, true],
    'advanced.eventsHistory.create': [false, true],
    'advanced.eventsHistory.get': [false, true],
    'advanced.eventsHistory.update': [false, true],
    'advanced.eventsHistory.remove': [false, true],
    'advanced.userComments.create': [false, true],
    'advanced.userComments.get': [false, true],
    'advanced.sendingsModeration.create': [false, true],
    'advanced.sendingsModeration.get': [false, true],
    'advanced.sendingsModeration.update': [false, true],
    'advanced.sendingsModeration.remove': [false, true],
    'advanced.sendingsModeration.getSendingsForTask': [false, true],
    'advanced.telemetry.create': [false, 'me', true],
    'advanced.telemetry.get': [false, 'me', true],
    'advanced.telemetry.update': [false, true],
    'advanced.telemetry.remove': [false, true],
    'advanced.platform.health': [false, true],
    'advanced.hlr.check': [false, 'me', true],
    'secret.showSecrets': [false, true],
    'secret.loginAs': [false, 'manager', 'reseller', true],
    'secret.viewChangelogs': [false, true]
};
//# sourceMappingURL=Permissions.js.map